import { configureStore } from "@reduxjs/toolkit";
import eventOrganiserSlice from "../components/features/Documents/redux/eventOrganiserSlice.js";
import userSlice from "../pages/user/redux/userSlice.js";
import signupSlice from "../components/features/user/redux/signupSlice.js";
// import authSlice from "../auth/authSlice";
// import prefillReducer from "../pages/prefills/redux/prefillSlice.js";

const store = configureStore({
  reducer: {
    eventOrganiser: eventOrganiserSlice,
    user: userSlice,
    signup: signupSlice,
    // authSlice: authSlice,
    // prefill: prefillReducer,
  },
});

export default store;
